import { getFontFacesCss } from '@wix/thunderbolt-becky-root'
import { Component, FontLoadStrategy } from '@wix/thunderbolt-becky-types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import { FeatureRefs } from '../cssFeatures.types'

export const fontFacesCss = createCssCompNode('fontFaces', 'fontFacesCss', {
	getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) => ({
		fontFaces: refs.fontFamilies(component),
		publicTopology: envRefs.publicTopology,
		fontLoadStrategy: envRefs.experiment('specs.thunderbolt.fontFacesFontDisplay'),
		wixSitesFontDisplaySwap: envRefs.experiment('specs.thunderbolt.wixSitesFontDisplaySwap'),
		isWixSite: envRefs.isWixSite,
	}),
	toViewItem: (
		__,
		{ fontFaces, publicTopology: { mediaRootUrl }, fontLoadStrategy, wixSitesFontDisplaySwap, isWixSite }
	) =>
		Array.from(fontFaces).map((fontFamily) =>
			getFontFacesCss(
				[fontFamily],
				mediaRootUrl,
				wixSitesFontDisplaySwap && isWixSite ? 'swap' : (fontLoadStrategy as FontLoadStrategy)
			)
		),
})
